export default {
    namespaced: true,

    state: {
        data: {
            last_name: "",
            first_name: "",
            middle_name: "",
            birth_date: "",
            phone: "",
            email: "",
            passport_series: "",
            passport_number: "",
            passport_subdivision_code: "",
            passport_subdivision_title: "",
            passport_date: "",
            address: "",
            is_middle_name_required: false,

            passport_photo_files: [],

            passport_address_files: [],

            transaction_date: "",

            transaction_provider_option: {
                text: null,
                id: null,
                icon: null,
                selected: false,
            },

            transaction_id: "",
            transaction_summ: "",
            payment_claim: "",
            payment_reason: "",

            credit_payment_delayed_date: "",
            credit_payment_delayed_transaction_summ: "",

            credit_debt_payment_delayed_date: "",
            credit_debt_payment_delayed_transaction_summ: "",

            payment_reason_other_text: "",
            debt_fine: "",
            debt_fine_text: "",
            additional_info: "",

            transaction_document_copy_attached: true,

            transaction_document_files: [],

            no_transaction_document_reason: "",

            debt_fine_document_copy_attached: true,

            debt_fine_document_files: [],

            no_debt_fine_document_reason: "",

            pd_agreement: false,
        },

        data_send: false
    },

    actions: {
        async CLAIM_SEND_DATA_ACT({ commit, dispatch }, sendData) {
            commit("setDataSend", { bool: false })
            
            try {
                let res = await BX.ajax.runComponentAction("vedita:application", "save", {
                    mode: "class",
                    data: {
                        post: sendData, //данные
                    },
                });

                commit("setDataSend", { bool: true })
            } catch (error) {
                dispatch("errorController/aggregateErrors", { error: error }, { root: true });
            }
        },
    },

    mutations: {
        setFirstStepData(state, { data }) {
            state.data.last_name = data.last_name;
            state.data.first_name = data.first_name;
            state.data.middle_name = data.middle_name;
            state.data.birth_date = data.birth_date;
            state.data.phone = data.phone;
            state.data.email = data.email;
            state.data.passport_series = data.passport_series;
            state.data.passport_number = data.passport_number;
            state.data.passport_subdivision_code = data.passport_subdivision_code;
            state.data.passport_subdivision_title = data.passport_subdivision_title;
            state.data.passport_date = data.passport_date;

            state.data.passport_photo_files = data.passport_photo_files;
            state.data.passport_address_files = data.passport_address_files;

            state.data.address = data.address;
            state.data.is_middle_name_required = data.is_middle_name_required;
        },

        setSecondStepData(state, { data }) {
            state.data.transaction_date = data.transaction_date;

            state.data.transaction_provider_option.text = data.transaction_provider_option.text;
            state.data.transaction_provider_option.id = data.transaction_provider_option.id;
            state.data.transaction_provider_option.icon = data.transaction_provider_option.icon;
            state.data.transaction_provider_option.selected = data.transaction_provider_option.selected;

            state.data.transaction_id = data.transaction_id;
            state.data.transaction_summ = data.transaction_summ;

            state.data.payment_claim = data.payment_claim;
            state.data.payment_reason = data.payment_reason;
            state.data.credit_payment_delayed_date = data.credit_payment_delayed_date;
            state.data.credit_payment_delayed_transaction_summ = data.credit_payment_delayed_transaction_summ;
            state.data.credit_debt_payment_delayed_date = data.credit_debt_payment_delayed_date;
            state.data.credit_debt_payment_delayed_transaction_summ = data.credit_debt_payment_delayed_transaction_summ;
            state.data.payment_reason_other_text = data.payment_reason_other_text;
            state.data.debt_fine = data.debt_fine;
            state.data.debt_fine_text = data.debt_fine_text;
            state.data.additional_info = data.additional_info;

            state.data.transaction_document_copy_attached = data.transaction_document_copy_attached;
            state.data.no_transaction_document_reason = data.no_transaction_document_reason;

            state.data.transaction_document_files = data.transaction_document_files;

            state.data.debt_fine_document_copy_attached = data.debt_fine_document_copy_attached;
            state.data.no_debt_fine_document_reason = data.no_debt_fine_document_reason;

            state.data.debt_fine_document_files = data.debt_fine_document_files;
        },

        setThirdStepData(state, { data }) {
            state.data.pd_agreement = data.pd_agreement;
        },

        setDataSend(state, { bool }) {
            state.data_send = bool;
        },
    },
};
